/* ========================================
   LBI Property Management — App JS
   ======================================== */

(function () {
  'use strict';

  // ---- Dark Mode Toggle ----
  const html = document.documentElement;
  const toggles = document.querySelectorAll('[data-theme-toggle], [data-theme-toggle-mobile]');
  let theme = matchMedia('(prefers-color-scheme:dark)').matches ? 'dark' : 'light';
  html.setAttribute('data-theme', theme);

  const sunIcon = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>';
  const moonIcon = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>';

  function updateIcons() {
    toggles.forEach(t => {
      t.innerHTML = theme === 'dark' ? sunIcon : moonIcon;
      t.setAttribute('aria-label', 'Switch to ' + (theme === 'dark' ? 'light' : 'dark') + ' mode');
    });
  }
  updateIcons();

  toggles.forEach(t => {
    t.addEventListener('click', () => {
      theme = theme === 'dark' ? 'light' : 'dark';
      html.setAttribute('data-theme', theme);
      updateIcons();
    });
  });

  // Show mobile theme toggle only on small screens
  const mobileToggle = document.querySelector('[data-theme-toggle-mobile]');
  function checkMobileToggle() {
    if (mobileToggle) {
      mobileToggle.style.display = window.innerWidth < 768 ? 'flex' : 'none';
    }
  }
  checkMobileToggle();
  window.addEventListener('resize', checkMobileToggle);

  // ---- Sticky Header ----
  const header = document.getElementById('site-header');
  const heroSection = document.getElementById('hero');

  function onScroll() {
    const scrolled = window.scrollY > 60;
    header.classList.toggle('scrolled', scrolled);

    // Check if still in hero
    if (heroSection) {
      const heroBottom = heroSection.getBoundingClientRect().bottom;
      header.classList.toggle('hero-visible', heroBottom > 80);
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ---- Mobile Menu ----
  const hamburger = document.getElementById('hamburger');
  const navMobile = document.getElementById('nav-mobile');

  if (hamburger && navMobile) {
    hamburger.addEventListener('click', () => {
      const isOpen = navMobile.classList.toggle('open');
      hamburger.classList.toggle('active', isOpen);
      hamburger.setAttribute('aria-expanded', String(isOpen));
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    // Close mobile nav on link click
    navMobile.querySelectorAll('.nav-link').forEach(link => {
      link.addEventListener('click', () => {
        navMobile.classList.remove('open');
        hamburger.classList.remove('active');
        hamburger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    });
  }

  // ---- Smooth Scroll ----
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const href = a.getAttribute('href');
      if (href === '#') return;
      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  // ---- Scroll Reveal (JS fallback for browsers without animation-timeline) ----
  const reveals = document.querySelectorAll('.reveal');

  if (!CSS.supports('animation-timeline', 'scroll()')) {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    reveals.forEach(el => observer.observe(el));
  } else {
    // If supports scroll-driven animations, just show everything
    reveals.forEach(el => {
      el.classList.add('visible');
    });
  }

  // ---- Contact Form ----
  const form = document.getElementById('contact-form');
  const formSuccess = document.getElementById('form-success');

  if (form) {
    form.addEventListener('submit', e => {
      e.preventDefault();
      form.style.display = 'none';
      formSuccess.classList.add('show');
    });
  }
})();
